import { useEffect, useState } from 'react'

/** AppShell's own breakpoint: below 768px the sidebar collapses into the Menu section. */
export const NARROW_QUERY = '(max-width: 767px)'

function isNarrow(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(NARROW_QUERY).matches
    : false
}

/**
 * True below 768px, live across resizes. App is its one reader and hands the answer to
 * AppShell, so the shell's layout and the placement of the session settings can never
 * disagree for a render.
 */
export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(isNarrow)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const query = window.matchMedia(NARROW_QUERY)
    const onChange = () => setNarrow(query.matches)
    onChange()
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])

  return narrow
}
